import { render, staticRenderFns } from "./OurTechPage.vue?vue&type=template&id=03ae16f0&scoped=true"
var script = {}
import style0 from "./OurTechPage.vue?vue&type=style&index=0&id=03ae16f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03ae16f0",
  null
  
)

export default component.exports